import React from 'react';
import { RouterProvider } from 'react-router-dom';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import { appRouter } from './app.router';
import './App.css';

function App() {
    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <RouterProvider router={appRouter} />
        </Container>
    );
}

export default App;
